// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrivateRoute_wrapper__i4PZd"};